import {ofType} from 'redux-observable';
import {Observable} from 'rxjs';
import {mergeMap, catchError} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Api from './api';
import * as Actions from './actions';

export const fetchPaymentMethods = (targetId: string, billPayerId?: string) =>
    Api.fetchPaymentMethods(targetId, billPayerId).map(({paymentMethods}) =>
        Actions.fetchPaymentMethodsSuccess.action(paymentMethods),
    );

const fetchPaymentMethodsEpic = action$ =>
    action$.pipe(
        ofType(Actions.fetchPaymentMethods.type),
        mergeMap(({payload}: ReturnType<typeof Actions.fetchPaymentMethods.action>) => {
            return fetchPaymentMethods(payload.targetId, payload.billPayerId).pipe(
                catchError(error => Observable.of(Actions.fetchPaymentMethodsFailed.action(error))),
            );
        }),
    );

export default combineEpics(fetchPaymentMethodsEpic);
